module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.thread) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.thread) ? _c('section', {
    staticClass: "posts"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.root)
    }
  }, [_vm._v(_vm._s(_vm.category.title))]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/" + _vm.root + "/" + (_vm.category.stringUrl) + "/" + (_vm.forum.stringUrl))
    }
  }, [_vm._v(_vm._s(_vm.forum.title))]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  }), _vm._v(" "), (_vm.thread.locked) ? _c('i', {
    staticClass: "fas fa-lock"
  }) : _vm._e(), _vm._v(" "), (_vm.thread.pinned) ? _c('i', {
    staticClass: "fas fa-thumbtack"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.thread.title) + "\n        ")], 1), _vm._v(" "), ((_vm.isModerator || _vm.isOriginalPoster) && !_vm.editMode && !_vm.deleteMode) ? _c('section', {
    staticClass: "controls"
  }, [_c('div', {
    on: {
      "click": _vm.enterEditMode
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" Edit")]), _vm._v(" "), (_vm.isModerator && !_vm.thread.pinned) ? _c('div', {
    on: {
      "click": _vm.savePinnedStatus
    }
  }, [_c('i', {
    staticClass: "fas fa-thumbtack"
  }), _vm._v(" Pin")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.thread.pinned) ? _c('div', {
    on: {
      "click": _vm.savePinnedStatus
    }
  }, [_c('i', {
    staticClass: "fas fa-thumbtack fa-rotate-270"
  }), _vm._v(" Unpin")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && !_vm.thread.locked) ? _c('div', {
    on: {
      "click": _vm.saveLockedStatus
    }
  }, [_c('i', {
    staticClass: "fas fa-lock"
  }), _vm._v(" Lock")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.thread.locked) ? _c('div', {
    on: {
      "click": _vm.saveLockedStatus
    }
  }, [_c('i', {
    staticClass: "fas fa-unlock"
  }), _vm._v(" Unlock")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.deleteMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" Delete")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('div', {
    on: {
      "click": function($event) {
        _vm.moveMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-right"
  }), _vm._v(" Move")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('section', {
    staticClass: "thread-controls-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editThreadTitle),
      expression: "editThreadTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Thread Subject"
    },
    domProps: {
      "value": (_vm.editThreadTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editThreadTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.editMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.saveEditThread
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.deleteMode) ? _c('section', {
    staticClass: "thread-controls-form"
  }, [_c('h3', [_vm._v("Are you sure you want to delete this thread and all the posts in it?")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.deleteMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.deleteThread
    }
  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (_vm.moveMode) ? _c('section', {
    staticClass: "thread-controls-form"
  }, [_c('h3', [_vm._v("Move To")]), _vm._v(" "), (_vm.moveToForumErrorMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.moveToForumErrorMessage))]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moveToForumId),
      expression: "moveToForumId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moveToForumId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.moveToForumErrorMessage = ''
      }]
    }
  }, _vm._l((_vm.moveModeForumsList), function(moveToForum) {
    return (moveToForum.id !== _vm.forum.id) ? _c('option', {
      domProps: {
        "value": moveToForum.id
      }
    }, [_vm._v(_vm._s(moveToForum.label))]) : _vm._e()
  })), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.moveMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.moveThread
    }
  }, [_vm._v("Move")])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "pagination"
  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "max-page": _vm.totalPages,
      "current-page": _vm.currentPage,
      "spread": 5
    },
    on: {
      "switchToPage": _vm.switchToResultsPage
    }
  })], 1), _vm._v(" "), (_vm.thread.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return (_vm.thread.fetchingStatus === 'fetched') ? _c('post', {
      attrs: {
        "post": post,
        "board-id": _vm.boardId
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.thread.locked) ? _c('add-post-form', {
    attrs: {
      "board-id": _vm.boardId,
      "category-id": _vm.category.id,
      "thread-id": _vm.thread.id
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "pagination"
  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "max-page": _vm.totalPages,
      "current-page": _vm.currentPage,
      "spread": 5
    },
    on: {
      "switchToPage": _vm.switchToResultsPage
    }
  })], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35b23351!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsPostList.vue
// module id = 848
// module chunks = 2